module.exports = __webpack_public_path__ + "static/media/combiLight.21b279c1.svg";